/**
 *获取项目id
 */
import {
  queryWastDateList,
  queryWastWaterDateList,
  queryRealWaterDateList,
  queryBigDataById,
  queryDateSkylist,
  queryWarn,
  querySiteBySt,
  querywastePollution,
  queryScreenWarn
} from '@/api/api'
import {
  getAction,
} from '@/api/manage'
import imgUrl from '@/assets/others/index/bg.gif'
import { setMapTile } from '@/utils/util.js'
import moment from 'moment'
const markerWarnState = false   //站点预警状态显隐
export const commonRender = {
  props: ['tabList'],
  watch: {

    tabList(val) {
      console.log('tabList')
      this.selectIndex = this.tabList[0].st
      this.selectType = this.tabList[0].st
      this.initTab()
    }

  },
  data() {
    return {
      standShape: '',
      markerWarnState,  //站点预警状态显隐
      onlineStateList: [{
        color: '#349d4d',
        title: '在线',
        name: '在',
        onlineState: true,
        show: true
      }, {
        color: '#ccc',
        title: '离线',
        name: '离',
        onlineState: false,
        show: true
      }, {
        color: 'red',
        title: '预警',
        name: '!',
        onlineState: false,
        show: markerWarnState
      }],
      labelState: false,
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
      },
      radioStatu: true,
      defaultValues: 1,
      radioIndex: '',
      timer: '',
      mapStyle: 'amap://styles/darkblue', //设置地图样式,
      mouseoverId: ''
    }
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.timer)
  },

  mounted() {
    // this.warnInter = setInterval(() => {
    // 	setTimeout(() => {
    // 		if (this.waterWarnList.length > 5) {
    // 			this.waterWarnList.push(this.waterWarnList[0]) // 将数组的第一个元素添加到数组的
    // 			this.waterWarnList.shift() //删除数组的第一个元素
    // 		}
    // 	}, 500)
    // }, 1000)
    // this.reportInter = setInterval(() => {
    // 	setTimeout(() => {
    // 		if (this.dateList.length > 13) {
    // 			this.dateList.push(this.dateList[0]) // 将数组的第一个元素添加到数组的
    // 			this.dateList.shift() //删除数组的第一个元素
    // 		}
    // 	}, 500)
    // }, 1000)
    // this.detailInter = setInterval(() => {
    // 	setTimeout(() => {
    // 		if (this.dateLists.length > 7) {
    // 			this.dateLists.push(this.dateLists[0]) // 将数组的第一个元素添加到数组的
    // 			this.dateLists.shift() //删除数组的第一个元素
    // 		}
    // 	}, 500)
    // }, 1000)
    // console.log('tabList',JSON.parse(JSON.stringify(this.tabList)))
    if (this.$store.getters.userInfo.st) {
      let obj = this.tabList.find(item => item.st == this.$store.getters.userInfo.st)
      if (obj) {
        this.selectIndex = this.$store.getters.userInfo.st
        this.selectType = this.$store.getters.userInfo.st
        this.initTab()
      }
    } else if (this.tabList && this.tabList.length > 0) {
      this.selectIndex = this.tabList[0].st
      this.selectType = this.tabList[0].st
      this.initTab()
    }
  },
  created() {

  },
  methods: {
    initTab() {

      if (this.selectIndex == '21') {
        this.distributeName = '水质分布'
        this.reportName = '水质日报'
        this.standShape = 'map-tag-cir'
      } else if (this.selectIndex == '22') {
        this.distributeName = '空气质量'
        this.reportName = '空气质量排名'
        this.standShape = 'map-tag-rec'
      } else if (this.selectIndex == 31) {
        this.standShape = 'map-tag-cir'
      }
      this.getApi(this.selectIndex, this.defaultValues)
    },
    setMapTile(map) {
      setMapTile(map)
    },
    selctTag(index, selectedIndex, id, isOnline) {
      console.log(index, selectedIndex, id, isOnline)
      console.log(this.standardList)
      console.log(this.markerList)
      console.log(this.selectIndex)
      if (isOnline) {
        this.standardList[selectedIndex].children[index].data.show = !this.standardList[selectedIndex].children[index].data.show
        let state = JSON.parse(JSON.stringify(this.standardList[selectedIndex].children[index].data.show))
        console.log(state)
        if (parseInt((this.selectIndex - 0) / 10) == 3) {
          this.markerList.forEach((item, index) => {
            if (item.upStandard == id) {
              item.show = state
            }
          })
        } else {
          this.markerList.forEach((item, index) => {
            if (item.currentStandard) {
              if (item.currentStandard.id == id) {
                item.show = state
              }
            }
          })
        }

      } else {
        this.onlineStateList[index].show = !this.onlineStateList[index].show
        let state = JSON.parse(JSON.stringify(this.onlineStateList[index].show))
        // 预警状态部分
        if (index == 2) {
          console.log('markerList', this.markerList)
          this.markerWarnState = !this.markerWarnState
          this.handleSite(this.markerList, this.selectType)
          // this.markerList.forEach((item, index) => {
          //   if (item.warnStatus == true) {
          //     item.show = state
          //   }
          // })
        } else {
          this.markerList.forEach((item, index) => {
            if (item.onlineStatus == id) {
              item.show = state
            }
          })
        }


      }
    },
    onToChangeLabel() {
      this.labelState = !this.labelState
      console.log('this.labelState', this.labelState)
      this.initMarker()
    },
    initMarker() {
      this.markerList.forEach(item => {
        if (this.labelState) {
          item['label'] = {
            content: item.name,
            offset: [0, -20]
          }
        } else {
          item['label'] = {
            content: '',
            offset: [0, 0]
          }
        }

      })
      this.monitorVideoList.forEach(item => {
        if (this.labelState) {
          item['label'] = {
            content: item.name,
            offset: [0, -20]
          }
        } else {
          item['label'] = {
            content: '',
            offset: [0, 0]
          }
        }
      })
    },
    toggledetailState(value) {
      if (value) {
        clearInterval(this.detailInter)
      } else {
        this.detailInter = setInterval(() => {
          setTimeout(() => {
            if (this.dateLists.length > 7) {
              this.dateLists.push(this.dateLists[0]) // 将数组的第一个元素添加到数组的
              this.dateLists.shift() //删除数组的第一个元素
            }
          }, 500)
        }, 1000)
      }
    },
    toggleReport(value) {
      console.log(value)
      if (value) {
        clearInterval(this.reportInter)
      } else {
        this.reportInter = setInterval(() => {
          setTimeout(() => {
            if (this.dateList.length > 13) {
              this.dateList.push(this.dateList[0]) // 将数组的第一个元素添加到数组的
              this.dateList.shift() //删除数组的第一个元素
            }
          }, 500)
        }, 1000)
      }
    },
    togglewarnState(value) {
      console.log(this.waterWarnList)
      if (value) {
        clearInterval(this.warnInter)
      } else {
        this.warnInter = setInterval(() => {
          setTimeout(() => {
            if (this.waterWarnList.length > 5) {
              this.waterWarnList.push(this.waterWarnList[0]) // 将数组的第一个元素添加到数组的
              this.waterWarnList.shift() //删除数组的第一个元素
            }
          }, 500)
        }, 1000)
      }
    },
    changeMap() {
      if (this.plugin[0].defaultType) this.plugin[0].defaultType = 0
      else this.plugin[0].defaultType = 1
      this.mapControlindex = 1
      this.window = null
      this.$nextTick(() => {
        this.mapControlindex = 0
        this.zoom = 15
        if (!this.selectType.startsWith('5') && !this.selectType.startsWith('6')) {
          this.getPollution(this.getDay(1), this.selectType)
        }
        this.$nextTick(() => {
          // setTimeout(() => {
          this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage
            .getItem('mapZoom') : 12
          // }, 500)
        })
        // this.changeVisible()
      })
    },
    // 获取对应标准的对应数据
    getStand(data) {
      if (data) {
        for (let i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title.replace('类', '')) {
            return i + 1
          }
        }
      } else {
        return 0
      }
    },
    // 获取主要污染物数据
    getPollution(start, st) {
      let params = {}
      params.st = st
      params.warnTimeStart = start
      params.warnTimeEnd = this.getDay(0)
      querywastePollution(params).then((res) => {
        if (res.success) {
          let title = []
          let value = []
          res.result.forEach((item, index) => {
            title.push(item.factorName ? item.factorName : '')
            value.push(item.warnSum)
          })
          if (this.$refs.column) {
            this.$refs.column.initBarChart(title, value)

          }
        }
      })
    },
    getSelectDay(e) {
      switch (e) {
        case 1:
          return this.getDay(1)
        case 2:
          return this.getDay(7)
        case 3:
          return this.getDay(30)
      }
    },
    // 主要污染物tab切换
    changeRadio(e) {
      let time
      switch (e.target.value) {
        case 1:
          time = this.getPollution(this.getDay(1), this.selectType)
          break
        case 2:
          time = this.getPollution(this.getDay(7), this.selectType)
          break
        case 3:
          time = this.getPollution(this.getDay(30), this.selectType)
          break
      }

    },
    // 点击详情中的查看详情跳转
    ontoSite() {
      sessionStorage.setItem('selectId', JSON.stringify(this.siteDetail))
      setTimeout(() => {
        this.$emit('siteTurn', true)
      }, 100)
    },
    // 预警tab切换
    changetadios(e) {
      this.defaultValues = e
      this.warnState = false
      this.$nextTick(() => {
        this.warnState = true
      })
      if (e == 0) this.radioIndex = ''
      else this.radioIndex = e
      this.getWarn(this.radioIndex, this.selectType)
    },
    // // 重新渲染地图上的站点
    // changeVisible() {
    //   let arr = []
    //   let stand = {}
    //   let windows = []
    //   let arr2 = []
    //   let that = this
    //   that.markerList.forEach((item, index) => {
    //     let position
    //     if (item.longitude != 'NaN') position = [item.longitude, item.latitude]
    //     else position = this.center
    //     item.position = position
    //     item.show = true
    //     if (item.st.startsWith('3')) {
    //       let icon
    //       switch (item.st) {
    //         case '31':
    //           icon = 'icon-wushuifeishui'
    //           break;
    //         case '32':
    //           icon = 'icon-yiliaofeishui'
    //           break;
    //         case '35':
    //           icon = 'icon-turang'
    //           break;
    //       }
    //       if (item.upStandard) {
    //         item.content = this.getWasteShape(
    //           'green',
    //           '',
    //           item.warnStatus,
    //           item.onlineStatus,
    //           item.name,
    //           icon
    //         )
    //       } else if (item.upStandard == null) {
    //         item.content = that.getWasteShape(
    //           '#ccc',
    //           '',
    //           item.warnStatus,
    //           item.onlineStatus,
    //           item.name,
    //           icon
    //         )
    //       } else {
    //         item.content = that.getWasteShape(
    //           'red',
    //           '',
    //           item.warnStatus,
    //           item.onlineStatus,
    //           item.name,
    //           icon
    //         )
    //       }
    //     } else if (item.st.startsWith('2')) {
    //       if (item.currentStandard) {
    //         if (item.st == '21') {
    //           item.content = that.getCir(
    //             item.currentStandard.color,
    //             item.currentStandard.title.replace('类', ''),
    //             item.warnStatus,
    //             item.onlineStatus,
    //             item.name
    //           )
    //         } else if (item.st == '22') {
    //           item.content = that.getRec(
    //             item.currentStandard.color,
    //             item.currentStandard.title,
    //             item.warnStatus,
    //             item.onlineStatus,
    //             item.name
    //           )
    //         }
    //
    //       } else {
    //         item.content = that.getnoneRec('#ccc', item.name, item.warnStatus, item
    //           .onlineStatus)
    //       }
    //       ;
    //     } else if (item.st.startsWith('6')) {
    //       if (item.currentStandard) {
    //         item.content = that.getCir(
    //           item.currentStandard.color,
    //           item.currentStandard.title.replace('类', ''),
    //           item.warnStatus,
    //           item.onlineStatus,
    //           item.name
    //         )
    //       } else {
    //         let icon
    //         switch (item.st) {
    //           case '61':
    //             icon = 'icon-shuikushuiwenzhan'
    //             break;
    //         }
    //         item.content = that.getnoneRec('#ccc', item.name, item.warnStatus, item
    //           .onlineStatus, icon)
    //       }
    //     }
    //
    //     (item.events = {
    //       click() {
    //         that.windows.forEach((window) => {
    //           window.visible = false //关闭窗体
    //         })
    //         that.window = that.windows[index]
    //         that.$nextTick(() => {
    //           // this.mainRealtime(item.id)
    //           that.window.visible = true //点击点坐标，出现信息窗体
    //           that.getsiteDetail(item.id) //获取对应id的站点详情
    //           that.getwaterStand(item.id) //获取当前水质标准
    //           that.getDateLists(item.id)
    //           // that.getSiteInfo(item.id)
    //           // that.queryOnlineById(item.id)
    //           // that.loadData(item.id)
    //         })
    //       },
    //     }),
    //       (arr = [])
    //     let positions
    //     if (item.longitude != 'NaN') positions = [item.longitude, item.latitude]
    //     else positions = that.center
    //     windows.push({
    //       position: positions,
    //       offset: [0, 0], //窗体偏移
    //       visible: false, //初始是否显示
    //       name: item.name,
    //       onlineStatus: item.onlineStatus,
    //       siteId: item.id,
    //     })
    //   })
    //   //加弹窗
    //   that.windows = windows
    //
    // },
    // 点击路况
    onselectRoad() {
      this.roadSelectindex = !this.roadSelectindex
      // this.$forceUpdate()
      // let a = this.$refs.maps.$$getInstance()
      if (this.plugin[0].showTraffic) this.plugin[0].showTraffic = false
      else this.plugin[0].showTraffic = true
      this.mapControlindex = 1
      this.window = null
      this.zoom = 15
      this.$nextTick(() => {
        // this.changeVisible()
        this.mapControlindex = 0
        if (!this.selectType.startsWith('5') && !this.selectType.startsWith('6')) {
          this.getPollution(this.getDay(1), this.selectType)
        }
        setTimeout(() => {
          this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage
            .getItem('mapZoom') : 12
        }, 1000)
      })
    },
    // 点击路网
    onselectNet() {
      this.netSelectindex = !this.netSelectindex
      if (this.plugin[0].showRoad) this.plugin[0].showRoad = false
      else this.plugin[0].showRoad = true
      this.mapControlindex = 1
      this.window = null
      this.zoom = 15
      this.$nextTick(() => {
        // this.changeVisible()
        this.mapControlindex = 0
        if (!this.selectType.startsWith('5') && !this.selectType.startsWith('6')) {
          this.getPollution(this.getDay(1), this.selectType)
        }
        setTimeout(() => {
          this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage
            .getItem('mapZoom') : 12
        }, 1000)
      })
    },
    // 点击卫星
    onselectMap(index) {
      this.mapSelectindex = !this.mapSelectindex
      this.changeMap()
    },
    // 一张图tab的切换
    OntoTab(st) {
      if (this.selectIndex == st) return
      this.selectIndex = st
      this.selectType = st
      this.mapControlindex = 1
      this.window = null
      this.zoom = 15
      this.reportState = false
      this.warnState = false
      this.defaultValues = 1
      this.$nextTick(() => {
        this.warnState = true
        this.reportState = true
        this.mapControlindex = 0
        // this.getPollution(this.getDay(1),this.selectType)
        setTimeout(() => {
          this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage
            .getItem('mapZoom') : 12
        }, 1000)
        // this.changeVisible()
      })
      if (st == 21) {
        this.distributeName = '水质分布'
        this.reportName = '水质日报'
        this.standShape = 'map-tag-cir'
      } else if (st == 22) {
        this.distributeName = '空气质量'
        this.reportName = '空气质量排名'
        this.standShape = 'map-tag-rec'
      } else if (st == 31) {
        this.standShape = 'map-tag-cir'
      }
      this.getApi(st, this.defaultValues)
    },
    // 站点marker数据处理
    handleSite(markerList, st) {
      let that = this
      let arr = []
      let stand = {}
      let windows = []
      let arr2 = []
      let onlineIndex = 0
      let unlineIndex = 0
      that.onlineNum = 0
      markerList.forEach((item, index) => {
        if (st.startsWith('3')) {
          if (item.onlineStatus) {
            onlineIndex++
          } else {
            unlineIndex++
          }
        }
        if (item.onlineStatus) {
          that.onlineNum++
        }
        if (item.longitude != 'NaN') item.position = [item.longitude, item.latitude]
        else item.position = ['118.04792', '24.61334']
        item.show = true
        item.title = item.name
        item.offset = [0, -3]
        if (this.labelState) {
          item['label'] = {
            content: item.name,
            offset: [0, -20]
          }
        } else {
          item['label'] = {
            content: '',
            offset: [0, 0]
          }
        }
        if (parseInt((item.st - 0) / 10) == 2 || parseInt((item.st - 0) / 10) ==
          5 || parseInt((item.st - 0) / 10) ==
          6) {
          if (item.currentStandard) {
            if (item.st == '21') {
              item.content = this.getCir(
                item.currentStandard.color ? item.currentStandard
                  .color : 'red',
                item.currentStandard.title.replace('类', ''),
                item.warnStatus,
                item.onlineStatus,
                item.name
              )
            } else if (item.st == '22') {
              item.content = this.getRec(
                item.currentStandard.color ? item.currentStandard
                  .color : 'red',
                item.currentStandard.title.replace('类', ''),
                item.warnStatus,
                item.onlineStatus,
                item.name
              )
            } else if (parseInt((item.st - 0) / 10) == 5) {
              item.content = this.getOval(
                item.currentStandard.color ? item.currentStandard
                  .color : 'red',
                item.currentStandard.title.replace('类', ''),
                item.warnStatus,
                item.onlineStatus
              )
            }
          } else {
            let icon
            switch (item.st) {
              case '61':
                icon = 'icon-shuikushuiwenzhan'
                break;
            }
            if (item.st != '22') item.content = that.getnoneRec('#349d4d', item
              .name, item.warnStatus, item.onlineStatus, icon)
            else item.content = this.getRec(
              '#349d4d',
              '',
              item.warnStatus,
              item.onlineStatus,
              item.name
            )
          }
        } else if (parseInt((item.st - 0) / 10) == 3) {
          let icon
          switch (item.st) {
            case '31':
              icon = 'icon-feiqi'
              break;
            case '32':
              icon = 'icon-wushuifeishui'
              break;
            case '35':
              icon = 'icon-turang'
              break;
          }
          if (item.upStandard == 'true') {
            item.content = this.getWasteShape(
              'green',
              '',
              item.warnStatus,
              item.onlineStatus,
              item.name,
              icon
            )
          } else if (item.upStandard == null) {
            if (item.onlineStatus) {
              item.content = that.getWasteShape('#349d4d', '', item.warnStatus, item.onlineStatus, item
                .name)
            } else {
              item.content = that.getWasteShape(
                'red',
                '',
                item.warnStatus,
                item.onlineStatus,
                item.name,
                icon
              )
            }
          } else {
            item.content = that.getWasteShape(
              'red',
              '',
              item.warnStatus,
              item.onlineStatus,
              item.name,
              icon
            )
          }
        }

        (item.events = {
          click() {
            that.windows.forEach((window) => {
              window.visible = false //关闭窗体
            })
            that.selectType = item.st
            that.window = that.windows[index]
            // that.center = [item.longitude, Number(item.latitude)]
            that.fileState = false
            that.$nextTick(() => {
              // this.mainRealtime(item.id)
              that.window.visible = true //点击点坐标，出现信息窗体
              that.getsiteDetail(item.id) //获取对应id的站点详情
              // 注释部分
              // st != '' ? that.getwaterStand(item.id) : '' //获取当前水质标准
              that.fileState = true
              // that.getSkyList(item.id)
              // that.getSiteInfo(item.id)
              // that.queryOnlineById(item.id)
              // that.loadData(item.id)
            })
          },
          mouseover() {
            that.mouseoverId = item.id
          },
          mouseout() {
            that.mouseoverId = ''
          }
        }),
          (arr = [])
        let positions
        if (item.longitude != 'NaN') positions = [item.longitude, item.latitude]
        else positions = that.center
        windows.push({
          position: positions,
          offset: [6, -33], //窗体偏移
          visible: false, //初始是否显示
          name: item.name,
          onlineStatus: item.onlineStatus,
          siteId: item.id,
        })
        // return item
      })
      // 污染源一站图的站点在线计算
      if (st.startsWith('3')) {
        let dataArr = [{
          'name': '离线',
          value: unlineIndex
        }, {
          'name': '在线',
          value: onlineIndex
        }]
        if (unlineIndex + onlineIndex == 0) {
          this.inlineRadio = '0%'
        } else {
          this.inlineRadio = ((onlineIndex / (onlineIndex + unlineIndex)) * 100).toFixed(
            0) + '%'
        }
        // },1000)
        if (this.$refs.ratio) {

          this.$refs.ratio.initBarChart(dataArr, this.inlineRadio)
          
        }
      }
      that.windows = windows
      this.markerList = markerList
    },
    // 获取各个站点数据
    getSite(st) {
      let that = this
      let param = st ? {
        st
      } : {}
      querySiteBySt(param).then((res) => {
        if (res.success) {
          this.handleSite(res.result, st)
          console.log('markerList', this.markerList)
        }
      })
    },
    // 获取到污染源类型的图标状态
    getWasteShape(bgColor, name, warnState, onlineState, siteName, icon) {
      let warnStyle = ''
      let onlineStyle = ''
      if (warnState && this.markerWarnState) {
        warnStyle = "<img style='width:20px;height:20px;position:absolute;right:-14px;top:-10px;' src='" +
          imgUrl + "' />"
      }
      if (!icon) {
        name = siteName.trim().substr(0, 1)
        console.log('name', name)
        console.log('siteName', siteName)
      }

      if (!onlineState) {
        bgColor = '#ccc'
        // onlineStyle =
        // 	"<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#fff;font-weight:400;'></div>"
      }
      return (
        "<div style='position: relative;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color: " +
        bgColor +
        ";text-align: center;color: #000;line-height: 30px;cursor: pointer;'><div style='width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:" +
        bgColor + "'></div><div title='" + siteName +
        "' style='position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:" +
        bgColor +
        ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'><div class='iconfont " +
        icon +
        "' style='font-size:15px;color:#fff;text-align: center;line-height: 30px;cursor: pointer;'></div>" +
        name +
        warnStyle +
        onlineStyle +
        "</div></div>"
      )
    },
    // 获取到圆
    getCir(bgColor, name, warnState, onlineState, siteName) {
      let warnStyle = ''
      let onlineStyle = ''
      if (warnState && this.markerWarnState) {
        warnStyle = "<img style='width:20px;height:20px;position:absolute;right:-14px;top:-10px;' src='" +
          imgUrl + "' />"
      }
      if (!onlineState) {
        bgColor = '#ccc'
        // onlineStyle =
        // 	"<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#fff;font-weight:400;'></div>"
      }
      return (
        "<div style='position: relative;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background:" +
        bgColor +
        ";text-align: center;color: #000;line-height: 40px;cursor: pointer;'><div style='width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:" +
        bgColor + "'></div><div title='" + siteName +
        "' style='position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:" +
        bgColor +
        ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'>" +
        name +
        warnStyle +
        onlineStyle +
        "</div></div></div>"
      )
    },
    // 未获取到当前标准
    getnoneRec(bgColor, name, warnState, onlineState, icon) {
      console.log('name', name)
      let warnStyle = ''
      let onlineStyle = ''
      let noneIcon = name.trim().substr(0, 1)
      if (warnState && this.markerWarnState) {
        warnStyle = "<img style='width:20px;height:20px;position:absolute;right:-14px;top:-10px;' src='" +
          imgUrl + "' />"
      }
      if (!onlineState) {
        bgColor = '#ccc'
        // onlineStyle =
        // 	"<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#fff;font-weight:400;'></div>"
      }
      if (icon) {
        noneIcon = "<div class='iconfont " + icon +
          "' style='font-size:15px;color:#fff;text-align: center;line-height: 30px;cursor: pointer;'></div>"
      }
      return (
        "<div style='position: relative;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color: #ccffff;text-align: center;color: #000;line-height: 40px;cursor: pointer;'><div style='width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:" +
        bgColor + "'></div><div title='" + name +
        "' style='position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:" +
        bgColor +
        ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'> " + noneIcon +
        warnStyle +
        onlineStyle +
        "</div></div>"
      )
    },
    // 获取到正方形
    getRec(bgColor, name, warnState, onlineState, siteName) {
      if (!name) {
        name = siteName.substr(0, 1)
      }
      let warnStyle = ''
      let onlineStyle = ''
      if (warnState && this.markerWarnState) {
        warnStyle = "<img style='width:30px;height:30px;position:absolute;right:-25px;top:-10px;' src='" +
          imgUrl + "' />"
      }
      if (!onlineState) {
        bgColor = '#ccc'
        // onlineStyle =
        // 	"<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#000;font-weight:400;'></div>"
      }
      return (
        "<div style='box-shadow:0 3px 6px #000;border-radius:3px;position:relative;width: 30px;height: 30px;font-size: 10px;background-color:" +
        bgColor +
        ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'" +
        "title='" +
        siteName +
        "'>" +
        name +
        warnStyle +
        onlineStyle +
        "</div></div><div style='width:8px;height:8px;margin: 0 auto;transform: rotate(45deg);margin-top: -4px;box-shadow: 0 3px 6px #000;background:" +
        bgColor +
        "'></div><div style='width:20px;height:7px;margin:0 auto;margin-top:-11px;transform:rotate(0);background:" +
        bgColor + "'></div>"
      )
    },
    // 获取到椭圆形
    getOval(bgColor, name, warnState, onlineState) {
      let warnStyle = ''
      let onlineStyle = ''
      if (warnState && this.markerWarnState) {
        warnStyle = "<img style='width:30px;height:30px;position:absolute;right:-30px;' src='" + imgUrl +
          "' />"
      }
      if (!onlineState) {
        onlineStyle =
          "<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#000;font-weight:400;'></div>"
      }
      return (
        "<div style='position:relative;width: 35px;border-radius: 10px;height: 35px;font-size: 10px;background-color:" +
        bgColor +
        ";text-align: center;color:#000;line-height: 35px;cursor: pointer;'>" +
        name +
        warnStyle +
        onlineStyle +
        '</div>'
      )
    },
    // 抽取公共渲染标准的方法
    standType(res) {
      let color = []
      let title = []
      let a = []
      let colors = ['green', 'red']
      let date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]]
      if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
        if (res.result[date[0]].upStandard == true) {
          color.push(colors[0])
          title.push('达标')
          a.push(1)
        } else {
          color.push(colors[1])
          title.push('不达标')
          a.push(2)
        }
      } else {
        color.push('')
        title.push('')
        a.push(0)
      }
      if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
        if (res.result[date[1]].upStandard == true) {
          color.push(colors[0])
          title.push('达标')
          a.push(1)
        } else {
          color.push(colors[1])
          title.push('不达标')
          a.push(2)
        }
      } else {
        color.push('')
        title.push('')
        a.push(0)
      }
      if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
        if (res.result[date[2]].upStandard == true) {
          color.push(colors[0])
          title.push('达标')
          a.push(1)
        } else {
          color.push(colors[1])
          title.push('不达标')
          a.push(2)
        }
      } else {
        color.push('')
        title.push('')
        a.push(0)
      }
      this.$refs.dials.initBarChart(title, color, date, a, 2)
    },
    // 用于渲染没有数据时
    standFailtype() {
      this.showDial = true
      let date = new Date()
      let year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      let year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      let year3 = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate()
      this.$nextTick(() => {
        this.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3],
          [0, 0, 0], 2)
      })
    },
    // 获取实时水质标准
    getwaterStand(id) {
      getAction(`/online/st${this.selectType}/standardBySite`, {
        scopeId: id,
        scope: 1
      }).then((res) => {
        if (this.selectType.startsWith('3')) {
          if (res.success) {
            this.standType(res)
          } else {
            this.standFailtype()
          }
        } else if (this.selectType == 21) {
          if (res.success) {
            let color = []
            let title = []
            let a = []
            let date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res
              .result)[1]]
            a.push(this.getStand(res.result[date[0]] ? res.result[date[0]].currentStandard :
              ''))
            a.push(this.getStand(res.result[date[1]] ? res.result[date[1]].currentStandard :
              ''))
            a.push(this.getStand(res.result[date[2]] ? res.result[date[2]].currentStandard :
              ''))
            if (res.result[date[0]] != null && res.result[date[0]].currentStandard != null) {
              color.push(res.result[date[0]].currentStandard.color)
              title.push(res.result[date[0]].currentStandard.title)
            } else {
              color.push('')
              title.push('')
            }
            if (res.result[date[1]] != null && res.result[date[1]].currentStandard != null) {
              color.push(res.result[date[1]].currentStandard.color)
              title.push(res.result[date[1]].currentStandard.title)
            } else {
              color.push('')
              title.push('')
            }
            if (res.result[date[2]] != null && res.result[date[2]].currentStandard != null) {
              color.push(res.result[date[2]].currentStandard.color)
              title.push(res.result[date[2]].currentStandard.title)
            } else {
              color.push('')
              title.push('')
            }
            this.$refs.dials.initBarChart(title, color, date, a, this.standardList.length)

            // let arr = []
            // let color = []
            // if(res.result['同比标准']){
            // 	color.push()
            // }
            // color.push()
          } else {
            this.showDial = true
            let date = new Date()
            let year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date
              .getDate()
            let year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
            let year3 = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate()
            this.$nextTick(() => {
              this.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [
                year1, year2, year3
              ], [0, 0, 0], 6)
            })
          }
        } else if (this.selectType == 22) {
          if (res.success && res.result) {
            this.$refs.plate.initBarChart(res.result['excellent'])
            this.$refs.doublePlate.initBarChart(res.result['PM25'], res.result['pollution'])
          } else {
            this.$refs.plate.initBarChart({
              someNum: 0,
              nowNum: 0
            })
            this.$refs.doublePlate.initBarChart({
              someNum: 0,
              nowNum: 0
            }, {
              someNum: 0,
              nowNum: 0
            })
          }
        }

      })
    },
    //获取预警内容
    getWarn(category, st) {
      this.radioIndex = category
      let params = st ? {
        // current: 1,
        // size: 20,
        category,
        st,
        warnStatus: 1
      } : {
        // current: 1,
        // size: 20,
        category,
        warnStatus: 1
      }
      if (this.warnStartTime) {
        params.stime = this.warnStartTime
        params.etime = this.getDay(0)
      }
      // 污水站点
      queryScreenWarn(params).then((res) => {
        if (res) {
          this.waterWarnList = res.result
        }
      })
      // }
    },
    // 获取对应的day天前的日期
    getDay(day) {
      let today = new Date()
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day
      today.setTime(targetday_milliseconds) //注意，这行是关键代码
      var tYear = today.getFullYear()
      var tMonth = today.getMonth()
      var tDate = today.getDate()
      let hour = today.getHours()
      let minute = today.getMinutes()
      let second = today.getSeconds()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)
      return tYear + '-' + tMonth + '-' + tDate
      // return tYear + '-' + tMonth + '-' + tDate + ' ' + hour + ':' + minute + ':' + second
    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length == 1) {
        m = '0' + month
      }
      return m
    },

    // 点击对应站点获取的站点详情
    getDateLists(id) {
      console.log('getDateLists', id)
      this.dateLists = []
      if (this.selectType == 21) {
        queryWastDateList({
          scopeId: id,
          // type: 1,
          st: this.selectType,
          scope: 1,
          column: 'data_time',
          // stime:this.getDay(0),
          // etime:this.getDay(0),
          order: 'desc'
        }).then((res) => {
          if (res.success && res.result.records.length > 0) {
            let state
            let arr = []
            let obj = {}
            res.result.query.factors.forEach((item, index) => {
              if (res.result.records[0].factor[item.code]) {
                obj.value = res.result.records[0].factor[item.code].value
                if (res.result.records[0].factor[item.code].standard) {
                  obj.standTitle = res.result.records[0].factor[item.code]
                    .standard.title
                  obj.standColor = res.result.records[0].factor[item.code]
                    .standard.color
                } else {
                  obj.standTitle = ''
                  obj.standColor = ''
                }
                switch (res.result.records[0].factor[item.code].status) {
                  case 0:
                    state = '无数据'
                    break
                  case 1:
                    state = '正常'
                    break
                  case 2:
                    state = '低报'
                    break
                  case 3:
                    state = '高报'
                    break
                  case 4:
                    state = '数据异常'
                    break
                }
                obj.state = state
                obj.render = this.renderCol(item.code, '', res.result.records[0])
                obj.title = item.title
                obj.unitName = item.unitName
                arr.push(obj)
                obj = {}
                state = ''
                return item
              }
            })
            this.standState = res.result.records[0].attrs.upStandard
            this.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标'
            this.standText = (res.result.records[0].attrs.currentStandard && res.result.records[
              0].attrs.currentStandard.title) ? res.result.records[0].attrs
                .currentStandard.title : ''
            this.dateLists = arr
          } else {
            res.result.query.factors.forEach((item, index) => {
              item.value = ''
              item.standColor = ''
              item.standTitle = ''
              item.state = ''
              item.render = ''
              return item
            })
            this.standState = false
            this.standText = ''
            this.standLabel = ''
            this.dateLists = res.result.query.factors
          }
        })
      } else if (this.selectType == 22) {
        clearInterval(this.timer)
        queryDateSkylist({
          scope: 1,
          scopeId: id,
          st: 22,
          type: 1,
        }).then((res) => {
          if (res.success && res.result.records.length > 0) {
            if (res.result.records[0].attrs.pollutions.length > 0) {
              this.$refs.instrument.initBarChart(
                res.result.records[0].attrs.pollutions[0].aqi,
                res.result.records[0].attrs.currentStandard.title,
                res.result.records[0].attrs.currentStandard.color
              )
              this.firstPollution = res.result.records[0].attrs.pollutions[0]
            } else {
              this.firstPollution = {}
              this.$refs.instrument.initBarChart(0, '无', '#fff')
            }

            let obj = {}
            let arr = []
            let title = []
            res.result.query.factors.forEach((item, index) => {
              // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
              if (res.result.records[0].factor[item.code] && res.result.records[0]
                .factor[item.code].value != null) {
                arr.push(res.result.records[0].factor[item.code].value)
                title.push(item.title)
              }
            })
            if (arr.length > 6) {
              this.$refs.bartypes.initBarChart(arr.slice(0, 6), title.slice(0, 6), 100)
              this.timer = setInterval(() => {
                if (this.$refs.bartypes) {
                  arr.push(arr[0]) // 将数组的第一个元素添加到数组的
                  arr.shift()
                  title.push(title[0]) // 将数组的第一个元素添加到数组的
                  title.shift()
                  this.$refs.bartypes.initBarChart(arr.slice(0, 6), title.slice(0,
                    6), 100)
                } else {
                  clearInterval(this.timer)
                }
              }, 2000)
            } else {
              this.$refs.bartypes.initBarChart(arr, title, 100)
            }
          } else {
            if (res.result.query.factors.length > 0) {
              let obj = {}
              let arr = []
              let title = []
              res.result.query.factors.forEach((item, index) => {
                // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
                arr.push(0)
                title.push(item.title)
              })
              if (res.result.query.factors.length > 6) {
                this.$refs.bartypes.initBarChart(arr.slice(0, 6), title.slice(0, 6), 100)
                this.timer = setInterval(() => {
                  if (this.$refs.bartypes) {
                    arr.push(arr[0]) // 将数组的第一个元素添加到数组的
                    arr.shift()
                    title.push(title[0]) // 将数组的第一个元素添加到数组的
                    title.shift()
                    this.$refs.bartypes.initBarChart(arr.slice(0, 6), title
                      .slice(0, 6), 100)
                  } else {
                    clearInterval(this.timer)
                  }
                }, 2000)

              } else {
                this.$refs.bartypes.initBarChart(arr, title, 100)
              }
            } else {
              this.$refs.bartypes.initBarChart([], [], 100)
            }
            this.$refs.instrument.initBarChart(0, '无', '#fff')
          }
        })
      } else if (this.selectType.startsWith('3')) {
        queryWastDateList({
          scopeId: id,
          type: 1,
          st: this.selectType,
          scope: 1
        }).then((res) => {
          if (res.success && res.result.records.length > 0) {
            let state
            let arr = []
            let obj = {}
            res.result.query.factors.forEach((item, index) => {
              if (res.result.records[0].factor[item.code]) {
                obj.value = res.result.records[0].factor[item.code].value
                // item.standTitle = res.result.records[0].factor[item.code].standard.title
                // item.standColor = res.result.records[0].factor[item.code].standard.color
                //         if (res.result.records[0].factor[item.code].status == 1) state='合格'
                // else if(res.result.records[0].factor[item.code].status == null) state = ''
                // else state = '不合格'
                if (res.result.records[0].factor[item.code].status == 1) obj
                  .standColor = 'green'
                else if (res.result.records[0].factor[item.code].status == null) obj
                  .standColor = ''
                else obj.standColor = 'red'
                obj.state = state
                obj.title = item.title
                obj.unitName = item.unitName
                obj.render = this.renderCol(item.code, '', res.result.records[0])
                obj.flagState = res.result.records[0].factor[item.code]['flag'] ? res.result.records[0].factor[item.code]['flag'].message : ''
                obj.flagCode = res.result.records[0].factor[item.code]['flag'] ? res.result.records[0].factor[item.code]['flag'].code : ''
                state = ''
                arr.push(obj)
                obj = {}
                return item
              }
            })
            this.standState = res.result.records[0].attrs.upStandard
            this.standText = res.result.records[0].attrs.upStandard ? '达标' : '不达标'
            this.dateLists = arr
          } else {
            res.result.query.factors.forEach((item, index) => {
              item.value = ''
              item.standColor = ''
              item.flagState = ''
              item.flagCode = ''
              item.render = ''
              return item
            })
            this.standState = false
            this.standText = ''
            this.dateLists = res.result.query.factors
          }
        })
      }
      else if (this.selectType.startsWith('6')) {
        let param = {
          st: this.selectType,
          order: 'desc',
          scopeId: id,
          scope: 1,
          searchCount: true
        }
        let url = `/online/st${this.selectType}/realtime/`
        if (this.selectType == 60 && this.siteDetail.category == 2) {
          param = {
            st: this.selectType,
            stime: moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
            etime: moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss'),
            order: 'desc',
            scopeId: id,
            scope: 1,
            searchCount: true
          }
          url = `online/st${this.selectType}/cn2061/`
        }
        getAction(url, param).then(res => {
          if (res.success) {
            if (res.result.records.length > 0) {
              let state
              let arr = []
              let obj = {}
              res.result.query.factors.forEach((item, index) => {
                if (res.result.records[0].factor[item.code]) {
                  obj.value = res.result.records[0].factor[item.code].value
                  if (res.result.records[0].factor[item.code].standard) {
                    obj.standTitle = res.result.records[0].factor[item.code]
                      .standard.title
                    obj.standColor = res.result.records[0].factor[item.code]
                      .standard.color
                  } else {
                    obj.standTitle = ''
                    obj.standColor = ''
                  }
                  switch (res.result.records[0].factor[item.code].status) {
                    case 0:
                      state = '无数据'
                      break
                    case 1:
                      state = '正常'
                      break
                    case 2:
                      state = '低报'
                      break
                    case 3:
                      state = '高报'
                      break
                    case 4:
                      state = '数据异常'
                      break
                  }
                  obj.state = state
                  obj.render = this.renderCol(item.code, '', res.result.records[0])
                  obj.title = item.title
                  obj.unitName = item.unitName
                  arr.push(obj)
                  obj = {}
                  state = ''
                  return item
                }
              })
              this.standState = res.result.records[0].attrs.upStandard
              this.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标'
              this.standText = (res.result.records[0].attrs.currentStandard && res.result.records[
                0].attrs.currentStandard.title) ? res.result.records[0].attrs
                  .currentStandard.title : ''
              this.dateLists = arr
            } else {
              res.result.query.factors.forEach((item, index) => {
                item.value = ''
                item.standColor = ''
                item.standTitle = ''
                item.state = ''
                item.render = ''
                return item
              })
              this.standState = false
              this.standText = ''
              this.standLabel = ''
              this.dateLists = res.result.query.factors
            }
          } else {
            this.dateLists = []
          }
        })
      }
    },

    // 渲染列
    renderCol(code, text, record) {
      let data = record.factor[code] || {
        value: '',
      }
      if (data.status == '2') {
        return (
          "<span  style='color:green;padding-left:15px' class='redText' title='原始数据：  " +
          (data.raw != null ? data.raw : '一') +
          "'>" +
          (data.value != null ? data.value : '一') +
          "<div class='iconfont icon-xiangxiajiantou' style='float:right;color:green' ></div></span>"
        )
      } else if (data.status == '3') {
        return (
          "<span style='color:red;padding-left:15px' title='原始数据：" +
          (data.raw != null ? data.raw : '一') +
          "'>" +
          (data.value != null ? data.value : '一') +
          "<div class='iconfont icon-iconset0414' style='float:right;color:red' ></div></span>"
        )
      } else {
        return "<span title='原始数据：" + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ?
          data.value : '一') + '</span>'
      }
    },
    // 获取对应点击的站点的站点详情
    getsiteDetail(id) {
      queryBigDataById({
        id,
      }).then((res) => {
        if (res.success) {
          res.result.photo = this.getImageView(res.result.photo)
          this.siteDetail = res.result
        }
        this.getDateLists(id)
      }).catch(() => {
        this.getDateLists(id)
      })
    },
    getImageView(photo) {
      return this.url.imgerver + '/' + photo
    },
  }
}
